import { log } from "@nudj-digital/observability/log";

export const logger: typeof log = log;
